import logoImage from "./assets/logo.png";
import logoWhiteImage from "./assets/logo-white.svg";

type LogoProps = {
  className?: string;
  variant?: "light" | "dark";
};

export const Logo: React.FC<LogoProps> = ({ className, variant = "dark" }) => {
  const logoSrc = variant === "light" ? logoWhiteImage : logoImage;
  return <img src={logoSrc} width={150} alt="Logo" className={className} />;
};
